import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import HrDashboard from '../../views/user/Dashboard/hr/IndexDashoard';
import NewHrDashboard from '../../views/Dashboard/hrDashboard/NewHrDashboard';
import Page404 from '../../views/user/Auth/Page404';
import OgmDashboard from '../../views/Dashboard/ogmDashboard/OgmDashboard';
import SogoWiseReport from '../../views/Dashboard/sogoDashboard/SogoWiseReport';
import FeeForcasting from '../../views/finance/Dashboard/FeeForcasting';
import AssetDash from '../../views/AssetDashboard/AssetDash';
import SRTdashboard from '../../views/sessionrescheduletracker/SRTdashboard';
import TrDashboard from '../../views/Dashboard/Tutorreplacement/TrDashboard';
import AssetDashboard from '../../views/assetmanagement/Dashboard/AssetDashboard';
import BatchDashBoardLanding from '../../views/Dashboard/batch/BatchDashBoardLanding';
import CRMdashboard from '../../views/crm/myworkspace/Dashboard/CRMdasboard';
import CROdashboard from '../../views/cro/myworkspace/Dashboard/CROdashboard';
import ImpactReport from '../../views/crd/myworkspace/ImpactReport/ImpactReport';
import StudentDashboard from '../../views/crd/myworkspace/ImpactReport/StudentDashboard';
import PendingPreAssessments from '../../views/crd/myworkspace/ImpactReport/Pending/PendingPreAssessments';
import PendingPostAssessments from '../../views/crd/myworkspace/ImpactReport/Pending/PendingPostAssessments';
import PendingExams from '../../views/crd/myworkspace/ImpactReport/Pending/PendingExams';
import PendingImpactReport from '../../views/crd/myworkspace/ImpactReport/Pending/PendingImpactReport';
import FinanceView from '../../views/finance/Dashboard/FinanceView';
import RefundDashboard from '../../views/refund/RefundDashboard';
import SkillxDashboardLanding from '../../views/Dashboard/skillx/SkillxDashboardLanding';
import RefundAnalyticsLanding from '../../views/Dashboard/refund/RefundAnalyticsLanding';
import DownloadedImpactReport from '../../views/crd/myworkspace/ImpactReport/Pending/DownloadedImpactReport';
import PlacementTrackerDashboard from '../../views/placementTracker/placementDahsboard/PlacementTrackerDashboard';

const DashboardRouter = () => {
  const { navChild, navConfig } = useSelector((state) => state.role);
  const [firstIndexDashboardPath, setFirstIndexDashboardPath] = useState('');
  useEffect(() => {
    const dashboardNav = navConfig.filter((data) => data?.title == 'dashboard');
    if (dashboardNav?.length > 0) {
      // console.log(dashboardNav[0].children?.[0].path.split('/')[1]);
      setFirstIndexDashboardPath(dashboardNav[0].children?.[0].path.split('/')[1]);
    }
  }, [navConfig]);

  return (
    <Routes>
      {navChild[0] && <Route path="/" element={<Navigate to={firstIndexDashboardPath} />} />}
      {/*-------------------- HR DASHBOARD------------------------- */}
      {navChild?.includes('analytics') && <Route path="/analytics" element={<NewHrDashboard />} />}
      {navChild?.includes('recruitment') && <Route path="/recruitment" element={<HrDashboard />} />}
      {/*-------------------- OGD DASHBOARD------------------------- */}
      {navChild?.includes('SOGO Assessment Overview') && <Route path="/ogm-assessment" element={<OgmDashboard />} />}
      {(navChild?.includes('SOGO Assessment Overview') || navChild?.includes('OGA Assessment Overview')) && (
        <Route path="/sogo-assessment" element={<SogoWiseReport />} />
      )}
      {/* -----------------------fee-forcasting-------------------------------------- */}
      <Route path="/fee-forecasting" element={<FeeForcasting />} />
      <Route path="/detailed-fin-view" element={<FinanceView />} />
      {/* -----------------------asset-dashboard------------------------------------ */}
      <Route path="/asset-dashboard" element={<AssetDashboard />} />
      {/* -------------------------------------- SRT DASHBOARD------------------------- */}
      <Route path="/srt-dashboard" element={<SRTdashboard />} />
      <Route path="/trt-dashboard" element={<TrDashboard />} />
      <Route path="/batch-dashboard" element={<BatchDashBoardLanding />} />
      {/* <Route path="refund-overview" element={<RefundDashboard />} /> */}

      {/* -------------------------------------- CRD DASHBOARD------------------------- */}
      <Route path="/crm-dashboard" element={<CRMdashboard />} />

      {/* -------------------------------------- CRO DASHBOARD------------------------- */}
      <Route path="/cro-dashboard" element={<CROdashboard />} />
      <Route path="/skillx-overview" element={<SkillxDashboardLanding />} />

      {/* ---------------------------------------- Impact Report  --------------------------------------------- */}

      <Route path="impact-report/:id" element={<ImpactReport />} />
      <Route path="student-dashboard" element={<StudentDashboard />} />

      {/* ----------------------------------------  Pending  --------------------------------------------- */}

      <Route path="pending-pre-assessments" element={<PendingPreAssessments />} />
      <Route path="pending-post-assessments" element={<PendingPostAssessments />} />
      <Route path="pending-exams" element={<PendingExams />} />
      <Route path="pending-impact-report" element={<PendingImpactReport />} />
      <Route path="impact-report-downloaded" element={<DownloadedImpactReport />} />
      <Route path="refund-overview" element={<RefundAnalyticsLanding />} />

      {/* ---------------------------------------- Placement Dashboard --------------------------------------------- */}
      <Route path="placement-dashboard" element={<PlacementTrackerDashboard />} />

      <Route path="*" element={<Page404 message={"you don't have the permission to perform such an action"} />} />
    </Routes>
  );
};

export default DashboardRouter;
